<template>
  <div id="app" ref="app">

  <router-view />

  </div>
</template>

<style lang="scss">

*{
  margin:0;
  padding:0;
  -webkit-box-sizing:content-box !important;
   box-sizing: content-box !important;
}

html,body{
  height: 100%;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}








</style>


<script>

	export default{
		name:'App',
		data(){
			return{

			}
		}
	}

</script>
